module.exports = __webpack_public_path__ + "img/success_check.5aa98b19.gif";